module.exports = __webpack_public_path__ + "static/media/poleBlank.97fc1c4b.svg";